<template>
<div class="chapter">
<div class="inner_page">
      ﻿
<title>Secretly Smitten</title><link href="default.css" rel="stylesheet" type="text/css"/><link href="page-template.xpgt" rel="stylesheet" type="application/vnd.adobe.page-template+xml"/>
<p class="ct" id="p0388-01-0"><a id="page388"></a><a href="#/chapter3">A<span class="small">CKNOWLEDGMENTS</span></a></p>
<p class="ser"><img alt="CKNOWLEDGMENTS" id="p0388-d6e12" src="images/9781401687137__0388_002.jpg" style="max-width: 100%;"/></p>
<p class="tx1" id="p0388-03-1"><span class="dcap2">W</span>hat a joy it’s been to work on our second Smitten novel! The idea for <i>Secretly</i> <i>Smitten</i> was conceived in a beautiful Indiana log cabin (we pretended it was Vermont) and met with much enthusiasm by our wonderful editors.</p>
<p class="tx" id="p0388-04-4">As with every book, <i>Secretly</i> <i>Smitten</i> is the result of a lot of hard work done by many people. We are so blessed to work with Thomas Nelson. They’ve been supportive of the Smitten series right from the start, and their enthusiasm has been contagious. Thanks to the entire fiction team led by Publisher Daisy Hutton: Ami McConnell, Natalie Hanemann, Katie Bond, Kristen Vasgaard, Ruthie Dean, Laura Dickerson, Becky Monds, Kerri Potts, Jodi Hughes, and Amanda Bostic. Love you all!</p>
<p class="tx" id="p0388-04-5">A special thanks to our editors: Ami McConnell and LB Norton. Their expertise is truly astounding; we’re so glad you have our backs!</p>
<p class="tx" id="p0388-04-6">Our agents Karen Solem and Lee Hough have been a huge help with this work and many others. Thanks, friends!</p>
<p class="tx" id="p0388-04-7">We’re thankful for our families, our backbones, as we juggle life and career.</p>
<p class="tx" id="p0388-04-8">Thanks to you, our reader—none of this would happen without you! We hope you enjoyed coming along on our journey back to Smitten.</p>
<p class="tx" id="p0389-01-0"><a id="page389">Our biggest thank-you goes to God, who brought the four of us together in a bond of unbreakable friendship. We’re all so different, and yet one, in our love for Christ and for one another.</a></p><a id="page389">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter51.vue?3ca100e9